var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { AuthenticationContext } from "./AuthenticationContext";
import jwt_decode from 'jwt-decode';
var AuthenticationProviderTokenHelpers = /** @class */ (function () {
    function AuthenticationProviderTokenHelpers(_token) {
        this._token = _token;
    }
    AuthenticationProviderTokenHelpers.prototype.getTokenExpiration = function () {
        if (this._token == null) {
            return new Date();
        }
        // check the session 
        var decodedToken = jwt_decode(this._token);
        // if token is outdated navigate to a new login 
        var expirationTimeStap = decodedToken.exp;
        if (!expirationTimeStap) {
            return null;
        }
        // calculate
        return new Date(expirationTimeStap * 1000);
    };
    return AuthenticationProviderTokenHelpers;
}());
export { AuthenticationProviderTokenHelpers };
export default function AuthenticationProvider(props) {
    var tokenStorageKey = props.tokenStorageKey || 'mv.token';
    var _a = React.useState(sessionStorage.getItem(tokenStorageKey)), token = _a[0], setToken = _a[1];
    var establishSession = function (tokenValue) {
        // set the token as current 
        sessionStorage.setItem(tokenStorageKey, tokenValue);
        setToken(tokenValue);
    };
    var destroySession = function (requestLogout) {
        sessionStorage.removeItem(tokenStorageKey);
        setToken(null);
        if (requestLogout) {
            window.location.replace(window.location.href + '?logout_requested=1');
        }
    };
    var verifySession = function () {
        // if we have no token good by 
        if (!token) {
            return true;
        }
        // get the expiration date
        var expirationDate = getTokenExpiration(token);
        if (!expirationDate) {
            return true;
        }
        // verif 
        return (expirationDate > new Date());
    };
    var getTokenExpiration = function (token) {
        var helpers = new AuthenticationProviderTokenHelpers(token);
        return helpers.getTokenExpiration();
    };
    return (_jsx(AuthenticationContext.Provider, __assign({ value: { tokenStorageKey: tokenStorageKey, currentToken: token, currentTokenExpiration: getTokenExpiration(token), authenticated: (token != null), establishSession: establishSession, destroySession: destroySession, verifySession: verifySession } }, { children: props.children })));
}
